class LazyVideo extends HTMLElement {
  constructor() {
    super();
    this.videoObserver = new IntersectionObserver(
      this.intersectionObserverHandler
    );
    this.videoObserver.observe(this.querySelector("video"));
  }

  intersectionObserverHandler(entries) {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        entry.target.getAttribute("data-autoplay") != "false"
      ) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }
}

customElements.define("fw-lazy-video", LazyVideo);
